import { SearchQuery } from 'modules/workflows/types/segmentation';

export type CriteriaCreateFormState = {
  searchQuery: SearchQuery;
  name: string;
  description?: string;
  isLive: string;
};

export enum CriteriaCreateFormFields {
  SEARCH_QUERY = 'searchQuery',
  NAME = 'name',
  DESCRIPTION = 'description',
  IS_LIVE = 'isLive',
}

export enum CriteriaTableTab {
  ALL = 'All',
  LIVE = 'Live',
  OFF = 'Off',
  ARCHIVED = 'Archived',
}

export enum CriteriaTableColumn {
  ANONYMOUS_CRITERIA = 'Name',
  STATUS = 'State',
  ACTIVITY = 'Activity',
  LAST_MODIFIED = 'LastModifiedBy',
  ACTIONS = 'Actions',
}
